import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import timeGridPlugin from '@fullcalendar/timegrid'
import { format } from 'date-fns'
import { getEventByEventID } from 'modules/Events/actions'
import React, { useEffect, useState, useRef  } from 'react'
import { useDispatch } from 'react-redux'
import PreviewDrawer from '../Preview/Partials/Drawer/PreviewDrawer'
import './Style/CalendarComponent.css'
import {
  BigText,
  SectionWrapper,
  SmallText,
  TitleOutline,
  TitleOutlineAll,
} from './Style/style'

const CalendarComponent = ({
  currentWeekStart,
  currentWeekEnd,
  calendarRef,
  eventList,
  isDrawerVisible,
  setIsDrawerVisible,
  handleDrawerClose,
  setRenderState
}) => {
  const [initialEvents, setInitialEvents] = useState([])
  const [previewData, setPreviewData] = useState(null)
  const sectionWrapperRef = useRef(null);
  const dispatch = useDispatch()
  const categoryStyles = {
    OTHERS: {
      borderColor: '#001B48',
      backgroundColor: 'rgba(0, 27, 72, 0.2)',
      textColor: 'White',
    },
    PRE_PLACEMENT_TALK: {
      borderColor: '#97CADB',
      backgroundColor: 'rgba(151, 202, 219, 0.2)',
      textColor: 'Black',
    },
    SEMINAR: {
      borderColor: '#B5A3F7',
      backgroundColor: 'rgba(181, 163, 247, 0.2)',
      textColor: 'Black',
    },
    WEBINAR: {
      borderColor: '#E1A7BA',
      backgroundColor: 'rgba(225, 167, 186, 0.2)',
      textColor: 'Black',
    },
    LECTURE: {
      borderColor: '#8D6AA0',
      backgroundColor: 'rgba(141, 106, 160, 0.2)',
      textColor: 'White',
    },
    CONFERENCE: {
      borderColor: '#F29F05',
      backgroundColor: 'rgba(242, 159, 5, 0.2)',
      textColor: 'Black',
    },
    PANEL_DISCUSSION: {
      borderColor: '#F25C05',
      backgroundColor: 'rgba(242, 92, 5, 0.2)',
      textColor: 'Black',
    },
    HACKATHON: {
      borderColor: '#31AAB5',
      backgroundColor: 'rgba(49, 170, 181, 0.2)',
      textColor: 'Black',
    },
    WORKSHOP: {
      borderColor: '#72B06F',
      backgroundColor: 'rgba(114, 176, 111, 0.2)',
      textColor: 'Black',
    },
    CAMPAIGN: {
      borderColor: '#4C1D91',
      backgroundColor: 'rgba(76, 29, 145, 0.2)',
      textColor: 'White',
    },
    SPORTS_EVENT: {
      borderColor: '#13593F',
      backgroundColor: 'rgba(19, 89, 63, 0.2)',
      textColor: 'White',
    },
    ACTIVITY_EVENT: {
      borderColor: '#02457A',
      backgroundColor: 'rgba(2, 69, 122, 0.2)',
      textColor: 'White',
    },
    EXHIBITION: {
      borderColor: '#595F33',
      backgroundColor: 'rgba(89, 95, 51, 0.2)',
      textColor: 'White',
    },
  }
  const typeLabels = {
    OTHERS: 'Others',
    PRE_PLACEMENT_TALK: 'Pre Placement Talk',
    SEMINAR: 'Seminar',
    WEBINAR: 'Webinar',
    LECTURE: 'Lecture',
    CONFERENCE: 'Conference',
    PANEL_DISCUSSION: 'Panel Discussion',
    HACKATHON: 'Hackathon',
    WORKSHOP: 'Workshop',
    CAMPAIGN: 'Campaign',
    SPORTS_EVENT: 'Sports Event',
    ACTIVITY_EVENT: 'Activity Event',
    EXHIBITION: 'Exhibition',
  }
  useEffect(() => {
    const splitMultiDayEvent = event => {
  
      const start = new Date(event.startDate);
    const end = new Date(event.endDate);
    const startDateOnly = new Date(start.toISOString().split('T')[0]);
    const endDateOnly = new Date(end.toISOString().split('T')[0]);
    const days = Math.ceil((endDateOnly - startDateOnly) / (1000 * 60 * 60 * 24)) + 1;
    const eventDays = [];
  
    for (let i = 0; i < days; i++) {
      const currentDate = new Date(startDateOnly.getTime() + i * (1000 * 60 * 60 * 24));
      const eventDay = {
        ...event,
        startDate: currentDate.toISOString(),
        endDate: currentDate.toISOString(),
      };
  
      if (i === 0) {
        eventDay.startDate = start.toISOString();
      }
      if (i === days - 1) {
        eventDay.endDate = end.toISOString();
      }
  
      eventDays.push(eventDay);
    }

    return eventDays;

    }
 


    let dataList = eventList?.result?.flatMap(event => {
      const regex = /T(\d{2}):(\d{2}):(\d{2}).(\d{3})Z/

      const allDay = event.allDayEvent
      const start = event?.startDate?.split('T')[0]
      const end = event?.endDate?.split('T')[0]
      const categoryStyle = categoryStyles[event.category] || {}
      const textColor = allDay
        ? categoryStyle.borderColor
        : categoryStyle.textColor

      if (start !== end) {
        return splitMultiDayEvent(event).map(dayEvent => ({
          start: allDay
            ? dayEvent?.startDate?.split('T')[0]
            : dayEvent?.startDate?.replace(
                regex,
                `T${event?.startTime + ':00'}`
              ),
          end: allDay
            ? dayEvent?.endDate?.split('T')[0]
            : dayEvent?.endDate?.replace(regex, `T${event?.endTime + ':00'}`),
          allDay: allDay,
          className: event?.className,
          category: typeLabels[event?.category],
          id: event?.id,
          title: event?.title,
          borderColor: allDay ? 'transparent' : categoryStyle.borderColor,
          backgroundColor: allDay ? 'none' : categoryStyle.backgroundColor,
          textColor: textColor,
        }))
      } else {
        return {
          start: allDay
            ? start
            : event?.startDate?.replace(regex, `T${event?.startTime + ':00'}`),
          end: allDay
            ? end
            : event?.endDate?.replace(regex, `T${event?.endTime + ':00'}`),
          allDay: allDay,
          className: event?.className,
          category: typeLabels[event?.category],
          id: event?.id,
          title: event?.title,
          borderColor: allDay ? 'transparent' : categoryStyle.borderColor,
          backgroundColor: allDay ? 'none' : categoryStyle.backgroundColor,
          textColor: textColor,
        }
      }
    })

    setInitialEvents(dataList)
  }, [eventList])

  useEffect(() => {
    const timeAxisHeader = document.querySelector('.fc-timegrid-axis')
    if (timeAxisHeader && !timeAxisHeader.querySelector('.fc-timegrid-axis')) {
      const timeAxisTitle = document.createElement('div')
      timeAxisTitle.className = 'fc-timegrid-axis'
      timeAxisTitle.innerText = 'Time'
      timeAxisHeader.insertBefore(timeAxisTitle, timeAxisHeader.firstChild)
    }
  }, [])

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      if (calendarRef.current) {
        calendarRef.current.getApi().updateSize();
      }
    });

    if (sectionWrapperRef.current) {
      resizeObserver.observe(sectionWrapperRef.current);
    }

    return () => {
      if (sectionWrapperRef.current) {
        resizeObserver.unobserve(sectionWrapperRef.current);
      }
    };
  }, []);
  const handleEventClick = async clickInfo => {
    let eventID = clickInfo?.event?.id
    let data = await dispatch(getEventByEventID({ eventId: eventID }))
    if (data?.status > 200 && data?.status < 300) {
      setPreviewData(data?.data?.data)
      setIsDrawerVisible(true)
    }
  }
  const handleDrawerClose1 = () => {
    setPreviewData(null)
    setIsDrawerVisible(false) // Set drawer visibility to false on close
    handleDrawerClose()
  }

  const renderEventContent = eventInfo => {
    const { title, extendedProps } = eventInfo.event
    const { category } = extendedProps

    if (eventInfo.event.allDay) {
      return (
        <>
          <TitleOutlineAll textColor={eventInfo.event.textColor}>
            {title?.toLowerCase()}
          </TitleOutlineAll>
          {/* <SmallText>{category}</SmallText> */}
        </>
      )
    } else {
      return (
        <>
          <TitleOutline
            textColor={eventInfo.event.textColor}
            backgroundColor={eventInfo.event.borderColor}
          >
            {title?.toLowerCase()}
          </TitleOutline>
          <SmallText>({category})</SmallText>
          <BigText>
            {format(new Date(eventInfo.event.start), 'p')} -{' '}
            {format(new Date(eventInfo.event.end), 'p')}
          </BigText>
        </>
      )
    }
  }

  return (
    <>
      <SectionWrapper  ref={sectionWrapperRef}>
        <FullCalendar
          ref={calendarRef}
          slotEventOverlap={false}
          plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
          headerToolbar={false}
          allDayText="All day"
          slotLabelContent={arg => {
            const date = new Date(arg.date)
            const hour = date.getHours()
            const ampm = hour >= 12 ? 'PM' : 'AM'
            const formattedHour = hour % 12 || 12
            return `${formattedHour} ${ampm}`
          }}
          initialView="timeGridWeek"
          slotDuration="01:00:00"
          nowIndicator={true}
          editable={false}
          selectable={true}
          selectMirror={false}
          dayMaxEvents={false}
          weekends={true}
          events={initialEvents}
          eventContent={renderEventContent}
          eventClick={handleEventClick}
          dayHeaderFormat={{ weekday: 'short', day: '2-digit' }}
          visibleRange={{
            start: currentWeekStart,
            end: currentWeekEnd,
          }}
          scrollTime={null}
        />
      </SectionWrapper>
      {isDrawerVisible && (
        <PreviewDrawer
          open={isDrawerVisible}
          onClose={handleDrawerClose1}
          eventDetails={previewData}
          setRenderState={setRenderState}
        />
      )}
    </>
  )
}

export default CalendarComponent
